module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABQ0lEQVRYR+2WPQ6CQBCFWWJjYeLdtMCCRAvgTLAmlFpows1sLCwMOEvAkA378yab0GBiYdiZ9znzZlgRLfwRC+tHK8BaAWMF8jyXZNCk67qzlPLJMWuWZQeKu9K3oRyXuRxGAAp+CSH2FPQliASFUOIUf6f4DcV/KH4LARRFcaTAm0qAQkzFVSyBnMqyfEAA6jAHAhFXGs4pQCBQcS8A30pwxL0BXBBccQjABNEnGdzuMhxswrkA3RPDmX5SbG437RGnCT0g1BGWONyCEUbreQ/AWVYsAN1w0xZwIKAWzLldAXA3JlQB26ghy0r3lFcFfOacC+EE8BEf/xUHwgqAiHMhbPeB//scnXOkEl4XEs6G0yDeVVXtoFVMCeq2bZM4jlPTZcK0XrV21PS7IYAUAnAlD/XcOQWhhIK+jEJCrRVYvAI/r/UyMJxRF7IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/close-x.png
// module id = wawi
// module chunks = 1